/**
 * Formulario de creación de nueva petición
 */
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

import { StateContext } from "../../../components/context/StateProvider";
import Toasts from "../../../components/notificacion/Toasts";
import { PeticionForm } from "../components";

// DECISION: Esta vista es intencionalmente delgada. Solo orquesta PeticionForm
// y gestiona la navegacion y los toasts. Toda la logica del formulario
// (validaciones, llamadas al servicio, reset) vive en PeticionForm.
const NuevaPeticion = () => {
    const { state, updateState } = useContext(StateContext);
    const navigate = useNavigate();

    // Navegar al listado del usuario al guardar o cancelar
    const navegarAMisPeticiones = () => {
        navigate('/mis-peticiones');
    };

    const handleSave = (_peticionCreada) => {
        const toast = Toasts.generateToast('Peticion creada correctamente', 'success');
        updateState({ toasts: [...state.toasts, toast] });
        navegarAMisPeticiones();
    };

    const handleError = (mensajeError) => {
        const toast = Toasts.generateToast(mensajeError, 'error');
        updateState({ toasts: [...state.toasts, toast] });
    };

    const handleCancel = () => {
        navegarAMisPeticiones();
    };

    return (
        <Box id="nueva-peticion" sx={{ width: "100%" }}>
            <PeticionForm
                onSave={handleSave}
                onError={handleError}
                onCancel={handleCancel}
            />
        </Box>
    );
};

export default NuevaPeticion;
